import { DateObject } from "react-multi-date-picker"

export const getDateFromDatePicker = (date: DateObject, isTime?: boolean) => {
    return date.year + "-" + (Number(date.month.toString()) < 10 ? "0" + date.month : date.month) + "-" + (Number(date.day.toString()) < 10 ? "0" + date.day : date.day)
}